import { Suspense, lazy } from 'react';

import { Navigate, RouteObject } from 'react-router-dom';
import { AppRoutes, StaticRoutes } from '../interfaces/router';

const OAuth2SuccessPage = lazy(() => import('../../pages/StaticPages/OAuth2/OAuth2Success.page'));
const OAuth2FailurePage = lazy(() => import('../../pages/StaticPages/OAuth2/OAuth2Failure.page'));

export const StaticController: RouteObject[] = [
  {
    path: StaticRoutes.OAuth2Success,
    element: (
      <Suspense fallback={ '' }>
        <OAuth2SuccessPage/>
      </Suspense>
    )
  },
  {
    path: StaticRoutes.OAuth2Failure,
    element: (
      <Suspense fallback={ '' }>
        <OAuth2FailurePage/>
      </Suspense>
    )
  },
  {
    path: '*',
    element: (
      <Navigate to={ AppRoutes.Home } replace/>
    )
  }
];
